// The app owns submission, validation, consent, and success states.
// This only offers recovery if the app fails to render any visible content.
function checkDeathBeforeForms() {
  document.querySelectorAll('[data-db-subscribe]').forEach((container) => {
    const fallback = container.querySelector('[data-db-form-fallback]');
    if (!fallback) return;
    const block = container.querySelector('.db-form-block');
    const hasContent = (node) => {
      if (!node) return false;
      if (node.matches?.('input, button, iframe, form')) return true;
      if (node.shadowRoot && hasContent(node.shadowRoot)) return true;
      return Array.from(node.children || []).some(hasContent);
    };
    // Read only: never inject styles or mutate the app's shadow DOM.
    fallback.hidden = hasContent(block);
  });
}
window.addEventListener('load', () => setTimeout(checkDeathBeforeForms, 15000), { once: true });
document.addEventListener('shopify:section:load', () => setTimeout(checkDeathBeforeForms, 15000));
document.addEventListener('click', (event) => {
  if (event.target.closest('[data-db-reload]')) window.location.reload();
});

// A still image remains underneath the video for loading and playback failures.
// The custom element also initializes when Shopify replaces a section in the editor.
if (!customElements.get('db-art-video')) {
  customElements.define('db-art-video', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const play = () => {
        if (motion.matches || document.hidden || video.error || this.events.signal.aborted) return;
        // Mobile browsers need an inline, visible, muted video at startup.
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.hidden = false;
        video.autoplay = true;
        video.preload = 'metadata';
        video.play().catch(() => {
          if (video.paused) video.hidden = true;
        });
      };
      video.addEventListener('playing', () => {
        if (motion.matches) {
          video.pause();
          video.hidden = true;
          return;
        }
        video.hidden = false;
      }, options);
      video.addEventListener('error', () => {
        video.hidden = true;
      }, options);
      motion.addEventListener('change', () => {
        if (motion.matches) {
          video.autoplay = false;
          video.pause();
          video.hidden = true;
        } else {
          play();
        }
      }, options);
      window.addEventListener('pageshow', play, options);
      document.addEventListener('visibilitychange', play, options);
      // A tap can start playback when the browser requires a user gesture.
      this.closest('.db-art-panel')?.addEventListener('pointerup', () => {
        if (video.paused) play();
      }, options);
      if (!motion.matches) play();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.querySelector('video')?.pause();
    }
  });
}
